import { stylesheet } from "typestyle"
import { getStyleTheme } from "@tm/context-distribution"

export function getComponentStyles() {
    const { margin } = getStyleTheme()

    return stylesheet({
        main: {
            display: "flex",
            alignItems: "center",
            marginBottom: margin.m,
        },
        area: {
            marginRight: margin.m,
        },
    })
}
